import React from 'react';

export default function Hero() {
  return (
    <div className="hero">
      <h1>Data Science Portfolio</h1>
      <p>Data-driven solutions for real-world impact.</p>
      <p>
        <a href="https://www.linkedin.com/in/matthew-mcnabb-a964007a/" target="_blank" rel="noopener noreferrer">
          <img alt="LinkedIn" src="https://img.shields.io/badge/LinkedIn-blue?logo=linkedin" />
        </a>
        <a href="mailto:mcnabb998@gmail.com">📧</a>
      </p>
    </div>
  );
}
